import React from "react";
import cn from "classnames";
import {
  IconChevronLeft,
  IconChevronRight,
  IconChevronsLeft,
  IconChevronsRight,
} from "@tabler/icons";
import { TableInstance } from "react-table";
import { CardFooter } from "../Cards";
import "../../../scss/_pagination.css";

export type DataTablePaginationProps<T extends object = {}> =
  TableInstance<T> & {
    setPageSizeFn: (value: number) => void;
  };

export const DataTablePagination = <T extends object = {}>(
  props: DataTablePaginationProps<T>
) => {
  const {
    state: { pageIndex, pageSize },
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setPageSizeFn,
    canPreviousPage,
    canNextPage,
    pageCount,
  } = props;

  const current = pageIndex + 1;

  return (
    <CardFooter className="d-flex align-items-center">
      <div className="text-muted">
        Rows per page:
        <div className="mx-2 d-inline-block">
          <select
            className="form-select form-select-sm"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPageSizeFn(Number(e.target.value));
            }}
          >
            {[10, 25, 50, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </div>
      </div>
      <p className="text-muted mb-0 ms-auto">{`Page ${
        pageIndex + 1
      } of ${pageCount}`}</p>
      <ul className="pagination mb-0 ms-auto">
        <li className={cn("page-item", { disabled: pageIndex === 0 })}>
          <a
            className="page-link"
            onClick={() => gotoPage(0)}
            tabIndex={-1}
            aria-disabled={!canPreviousPage}
          >
            <IconChevronsLeft />
          </a>
        </li>
        <li className={cn("page-item", { disabled: !canPreviousPage })}>
          <a
            className="page-link"
            onClick={() => previousPage()}
            tabIndex={-1}
            aria-disabled={!canPreviousPage}
          >
            <IconChevronLeft /> prev
          </a>
        </li>
        <li className={cn("page-item", { disabled: !canNextPage })}>
          <a
            className="page-link"
            onClick={() => nextPage()}
            aria-disabled={!canNextPage}
          >
            next <IconChevronRight />
          </a>
        </li>
        <li className={cn("page-item", { disabled: !canNextPage })}>
          <a
            className="page-link"
            onClick={() => gotoPage(pageCount - 1)}
            aria-disabled={!canNextPage}
          >
            <IconChevronsRight />
          </a>
        </li>
      </ul>
    </CardFooter>
  );
};

export default DataTablePagination;
